import service from '../providers/service.js';
import { tokenize } from "../helpers/token.js";
import { SET_DONORS, SET_SELECTED_DONOR } from "./types.js";
import BrowserHistory from "../providers/BrowserHistory.js";
import { setErrors } from "./error.js";

// Create new donor
export function createDonor(donor) {
  return dispatch => {
    service
      .post(tokenize(`/api/donors`), donor)
      .then(response => {
        if (response.data.message === 'donor.success') {
          dispatch(fetchDonors());
          BrowserHistory.push('/main/donors');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Update donor
export function updateDonor(donor) {
  return dispatch => {
    service
      .post(tokenize(`/api/donors/${donor.id}`), donor)
      .then(response => {
        if (response.data.message === 'donor.success') {
          dispatch(fetchDonors());
          BrowserHistory.push('/main/donors');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Delete donor
export function deleteDonor(donorId) {
  return dispatch => {
    service
      .post(tokenize(`/api/donors/${donorId}/destroy`))
      .then(response => {
        if (response.data.message === 'donor.success') {
          dispatch(fetchDonors());
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Fetch all donors
export function fetchDonors() {
  return dispatch => {
    service
      .get(tokenize(`/api/donors`))
      .then(response => {
        dispatch(setDonors(response.data.donors));

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Fetch donor by id
export function fetchDonor(donorId) {
  return dispatch => {
    service
      .get(tokenize(`/api/donors/${donorId}`))
      .then(response => {
        dispatch(setSelectedDonor(response.data.donor));

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// set donors to store
export function setDonors(donors) {
  return {
    type: SET_DONORS,
    donors: donors
  };
}

// Set selected donor from form to state
export function setSelectedDonor(donor) {
  return {
    type: SET_SELECTED_DONOR,
    donor: donor
  };
}


// WEBPACK FOOTER //
// ./src/actions/donor.js